<template>
  <div class="FiCreditorSTRequestList">
    <AppBar />

    <!-- createSettlementRequest drawer  -->
    <component
      v-if="showSettlementReqDrawer"
      :is="createSettlementReqFFormMetaData.componentName"
      :ref="createSettlementReqFFormMetaData.myRefName"
      :value="selectModel(createSettlementRequestInput, undefined)"
      @input="
        (newValue) =>
          updateModel(createSettlementRequestInput, newValue, undefined)
      "
      v-bind="createSettlementReqFFormMetaData.props"
    ></component>

    <!-- DataTable  -->
    <component
      :is="stRequestFDataTableMetaData.componentName"
      :ref="stRequestFDataTableMetaData.myRefName"
      :value="selectModel(filteredSRTaskList, undefined)"
      v-bind="stRequestFDataTableMetaData.props"
    >
    </component>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import store, * as Store from "@/../src-gen/store";
import * as Data from "@/../src-gen/data";
import * as Action from "@/../src-gen/action";
import ModelVue from "@/components/ModelVue";
import FForm from "@/components/form/FForm.vue";
import FDataTable from "@/components/table/FDataTable.vue";
import FFormDrawer from "@/components/form/FFormDrawer.vue";
import FSnackbar from "@/fsnackbar";
import AppBar from "@/components/bar/chppAppBar.vue";
import FDrawer from "@/components/FDrawer.vue";
import STRequestFDataTableMDP from "./FiCreditorSTRequestList/STRequestFDataTableMDP";
import CreateSettlementReqFFormMDP from "./FiCreditorSTRequestList/CreateSettlementReqFFormMDP";

@Component({
  components: {
    FForm,
    FDataTable,
    FFormDrawer,
    AppBar,
    FDrawer,
  },
})
export default class FiCreditorSTRequestList extends ModelVue {
  @Store.Getter.Login.LoginDetails.userName
  userName: string;

  searchSettlementTaskInput: Data.Spine.SearchSettlementTaskInput =
    new Data.Spine.SearchSettlementTaskInput();

  searchSettlementTaskOutput: Data.Spine.SearchSettlementTaskOutput =
    new Data.Spine.SearchSettlementTaskOutput();

  createSettlementRequestInput: Data.Spine.CreateSettlementRequestInput =
    new Data.Spine.CreateSettlementRequestInput();

  showSettlementReqDrawer: boolean = false;

  get fiCreditorId() {
    return this.$route.params.fiCreditorId;
  }

  get stRequestFDataTableMetaData() {
    return new STRequestFDataTableMDP({
      parent: this,
    }).getMetaData();
  }

  get createSettlementReqFFormMetaData() {
    return new CreateSettlementReqFFormMDP({
      parent: this,
      isVisible: this.showSettlementReqDrawer,
      onClose: () => {
        this.showSettlementReqDrawer = false;
      },
    }).getMetaData();
  }


  get filteredSRTaskList() {
    let data =  this.searchSettlementTaskOutput.taskList.filter(
      (settlementTask) =>
        (settlementTask.taskInput as any).fiCreditorId === this.fiCreditorId
    );
    return data;
  }

  handleCreateSettlementRequestClick() {
    this.showSettlementReqDrawer = true;
    this.createSettlementRequestInput.fiCreditorId = this.fiCreditorId;
  }

  searchSettlementTask() {
    Action.Spine.SearchSettlementTask.execute(
      this.searchSettlementTaskInput,
      (output) => {
        this.searchSettlementTaskOutput = output;
      },
      (error) => {
        console.log("error from SearchSettlementTask", error);
      }
    );
  }

  createSettlementRequest() {
    Action.Spine.CreateSettlementRequest.execute(
      this.createSettlementRequestInput,
      (output) => {
        FSnackbar.success("Succesfully created the settlement request task");
        this.searchSettlementTask();
        this.showSettlementReqDrawer = false;
        this.createSettlementRequestInput = new Data.Spine.CreateSettlementRequestInput();
      },
      (error) => {
        console.log("error from  createSettlementRequest", error);
      }
    );
  }

  mounted() {
    this.searchSettlementTask();
  }
}
</script>

<style>
</style>
